import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum IdentityDetailsFormErrorStatesEnum {
    CreateDetailsFailed = ErrorStateScheduleEnum.IdentityDetailsFormStatesStartIndex,
    UpdateDetailsFailed
}
